<app-page-wrapper [title]="'estimates' | i18n">
  <div>
    <div class="estimate-table-container">
      <nav class="navbar navbar-expand-lg navbar-light nav-transactions">
        <div class="navigation-container">
          <!-- A real button (was a clickable, aria-hidden <i>) so Add is reachable with Tab. -->
          <button
            type="button"
            class="tw-p-0 tw-leading-none"
            [attr.aria-label]="'add' | i18n"
            (click)="openEstimateForm(null)"
          >
            <i aria-hidden="true" class="bwi bwi-plus bwi-fw add-estimate-icon"></i>
          </button>
        </div>
      </nav>
      <table mat-table [dataSource]="dataSource" matSort>
        <ng-container matColumnDef="name">
          <th mat-header-cell *matHeaderCellDef mat-sort-header>Estimate</th>
          <td mat-cell *matCellDef="let element" class="transaction-table__column-text">
            {{ element.name }}
          </td>
        </ng-container>

        <ng-container matColumnDef="categories">
          <th mat-header-cell *matHeaderCellDef mat-sort-header>Categories</th>
          <td mat-cell *matCellDef="let element" class="transaction-table__column-text">
            {{ element.categories | categoryPipe: "getCategoriesNamesList" | async }}
          </td>
        </ng-container>

        <ng-container matColumnDef="classifications">
          <th mat-header-cell *matHeaderCellDef mat-sort-header>Classifications</th>
          <td mat-cell *matCellDef="let element" class="transaction-table__column-text">
            {{
              element.classifications | classificationPipe: "getClassificationsNamesList" | async
            }}
          </td>
        </ng-container>

        <ng-container matColumnDef="account">
          <th mat-header-cell *matHeaderCellDef mat-sort-header>Account</th>
          <td mat-cell *matCellDef="let element" class="transaction-table__column-text">
            {{ element.accountId | bookPipe: "getBookName" | async }}
          </td>
        </ng-container>

        <ng-container matColumnDef="direction">
          <th mat-header-cell *matHeaderCellDef mat-sort-header>Direction</th>
          <td mat-cell *matCellDef="let element" class="transaction-table__column-text">
            {{ element.direction }}
          </td>
        </ng-container>

        <ng-container matColumnDef="period">
          <th mat-header-cell *matHeaderCellDef mat-sort-header>Frequency/Period</th>
          <td mat-cell *matCellDef="let element" class="transaction-table__column-text">
            {{ element | estimatePipe: "getEstimateFreqAndPeriod" | async }}
          </td>
        </ng-container>

        <ng-container matColumnDef="value">
          <th mat-header-cell *matHeaderCellDef mat-sort-header arrowPosition="before">Value</th>
          <td mat-cell *matCellDef="let element" class="transaction-table__column-number">
            {{ element.initialValue | currency: element.symbol }}
          </td>
        </ng-container>

        <ng-container matColumnDef="edit">
          <th mat-header-cell *matHeaderCellDef class="actions"></th>
          <td mat-cell *matCellDef="let row; let i = index" class="actions">
            <button
              mat-icon-button
              color="primary"
              matTooltip="Edit"
              [attr.aria-label]="'edit' | i18n"
              (click)="openEstimateForm(row)"
            >
              <i aria-hidden="true" class="bwi bwi-pencil-square bwi-fw"></i>
            </button>
          </td>
        </ng-container>

        <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
        <tr mat-row *matRowDef="let estimate; columns: displayedColumns"></tr>
      </table>
    </div>
  </div>
</app-page-wrapper>
